export default __webpack_public_path__ + "static/media/srisailamVisitSeventeen.7e955c65.jpg";